import React, { useEffect, useState } from "react";
import {
  FINANCE_V2_HOSTNAME,
  INTRANETHOSTNAME,
  REPORT_HOSTNAME,
} from "../../../../common-utilities/utils/end-points";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { getHeaderConfig } from "./helper";
import "./index.scss";
import MuiTable from "../../../../common-utilities/core/mui-table";
import { FINANCE_REST_URLS } from "../../../../common-utilities/utils/end-points/finance-v2";
import { useNavigate } from "react-router-dom";
import { Autocomplete, Button, TextField } from "@mui/material";
import DateRangeFilter from "../../../../common-utilities/core/date-range-filter";
import { downloadReports } from "./utils";
import PoFilters from "../../purchase-order/po-filters";
import { grnStatusList } from "./constants";
import {
  getStartOfDay,
  getEndOfDay,
} from "../../../../common-utilities/utils/time";
import FinancialYearDropdown,{getFinancialYears} from "../../home/financial-year-dropdown";
import { getOfflineData } from "../../../utils/offline-services";
const GRNList = ({ status }) => {
  const navigate = useNavigate();
  const isVendorUserInit =
    getOfflineData("user")?.role?.toLowerCase().includes("vendor") || false;
  const { defaultFY } = getFinancialYears();
  const [budgetList, setBudgetList] = useState({});
  const [searchKey, setSearchKey] = useState("");
  const [isVendorUser, setIsVendorUser] = useState(false);
  const [isDepartmentRole, setIsDepartmentRole] = useState(false);
  const [departmentList, seDepartmentList] = useState([]);
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortBy: "-createdAt",
    ...(isVendorUserInit ? { financialYear: defaultFY } : {}),
  });

  useEffect(() => {
    if (status) {
      loadData(filters);
    }
  }, [status]);

  const loadData = (apiFilters, download) => {
    let params = {
      ...apiFilters,
    };
    if (params.startDate) {
      params.startDate = getStartOfDay(params.startDate);
    }
    if (params.endDate) {
      params.endDate = getEndOfDay(params.endDate);
    }
    if (status !== "all") {
      params.status = status;
    }
    params.populateSite = true;
    if (searchKey) {
      params.searchKey = searchKey;
    }

    invokeApi(
      HTTP_METHODS.GET,
      `${download ? REPORT_HOSTNAME : FINANCE_V2_HOSTNAME}${FINANCE_REST_URLS.GRN_LIST}`,
      null,
      params
    )
      .then((response) => {
        if (download) {
          downloadReports(response?.results || [], status);
          return;
        }
        setBudgetList(response);
      })
      .catch((err) => {});
  };

  const viewBudget = (data, type) => {
    const { purchaseOrderId, approvalId = {}, invoiceDataId } = data;
    if (type === "EDIT") {
      navigate(`grn-order/edit/${data.id}?poId=${purchaseOrderId.id}`);
    } else if (approvalId && approvalId.id) {
      navigate(
        `invoice-data/${invoiceDataId}?approvalId=${approvalId.id}&from=GRN`
      );
    } else {
      navigate(`grn-order/${data.id}`);
    }
  };
  const loadDepartments = (params) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${INTRANETHOSTNAME}${FINANCE_REST_URLS.DEPARTMENTS}`,
      null,
      params
    )
      .then((response) => {
        if (response.message) {
        } else {
          const results = response?.map((ele) => ({
            label: ele?.name,
            value: ele?._id,
          }));
          seDepartmentList(results || []);
        }
      })
      .catch((err) => {});
  };
  useEffect(() => {
    const user = getOfflineData("user");
    if (user?.role?.includes("VENDOR")) {
      setIsVendorUser(true);
    }
    const roleNorm = (user?.role || "").toLowerCase().replace(/\s+/g, "_");
    if (roleNorm === "department_user" || roleNorm === "department_read_only") {
      setIsDepartmentRole(true);
      setFilters((prev) => ({ ...prev, department: user?.department }));
    }
    loadDepartments();
  }, []);

  return (
    <div className="finance-v2-budget-list">
      <div className="filter-row">
        <TextField
          placeholder="Search by GRN/PO Number"
          value={searchKey}
          size="small"
          onChange={(e) => setSearchKey(e.target.value)}
        />
        <PoFilters
          filters={filters}
          setFilters={setFilters}
          showStatus={true}
          statusList={grnStatusList}
          disableStatus={status !== "all"}
          showVendorDropDown={isVendorUser ? false : true}
        />
        <Autocomplete
          disabled={isDepartmentRole}
          value={
            filters?.department
              ? departmentList.find(
                  (item) => item.value === filters?.department
                )
              : null
          }
          onChange={(e, val) => {
            if (val?.value) {
              setFilters((prevVal) => ({ ...prevVal, department: val?.value }));
            } else {
              setFilters((prev) => {
                const { department, ...rest } = prev;
                return rest;
              });
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              label="Department"
              sx={{
                minWidth: 200,
              }}
            />
          )}
          options={departmentList}
        />
        <FinancialYearDropdown filters={filters} setFilters={setFilters} disabled={isVendorUser} />
        <DateRangeFilter
          startDate={filters?.startDate}
          endDate={filters?.endDate}
          setDateRange={setFilters}
        />
        <Button
          variant="outlined"
          onClick={() => {
            setFilters({
              ...filters,
              page: 1,
            });
            loadData({
              ...filters,
              page: 1,
            });
          }}
        >
          Search
        </Button>

        <Button
          variant="outlined"
          disabled={!budgetList.totalResults}
          onClick={() => {
            loadData(
              {
                ...filters,
                page: 1,
                limit: budgetList.totalResults,
              },
              true
            );
          }}
        >
          Download
        </Button>
      </div>

      <MuiTable
        columnsList={getHeaderConfig(viewBudget, status, isVendorUser)}
        dataList={budgetList.results || []}
        filters={filters}
        pageCount={budgetList.totalPages}
        onChange={(page) => {
          setFilters({
            ...filters,
            page,
          });
          loadData({
            ...filters,
            page,
          });
        }}
      />
    </div>
  );
};

export default GRNList;
